export const copyToastMessages = {
    success: 'Printing proposal copied.',
    error: 'Error copying printing proposal.'
};

export const deleteToastMessages = {
    success: 'Printing proposal removed.',
    error: 'Error removing printing proposal.'
};

export const setPrimaryToastMessages = {
    success: 'Printing proposal set as primary.',
    error: 'Error setting printing proposal as primary.'
};

export const getToastMessage = {
    error: 'Failed to retrieve proposals list.',
    success: undefined
};
